import { render, staticRenderFns } from "./accounts-receivable-header.vue?vue&type=template&id=79592e76&"
import script from "./accounts-receivable-header.vue?vue&type=script&lang=js&"
export * from "./accounts-receivable-header.vue?vue&type=script&lang=js&"
import style0 from "./accounts-receivable-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports